import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withPrefix } from 'gatsby';

import SEO from '../components/seo';

import Layout from '../layouts/main';
import Bluebox from '../components/bluebox';
import RegulationButton from '../components/regulationsButton';
import LoginForm from '../components/loginForm';
import Questions from '../components/questions';
import Results from '../components/results';
import Popup from '../components/popup';

import isIE from '../utils/isIE';

import quizContent from '../../content/quiz.json';

const IndexPage = ({ isForm, isQuestions, isResults }) => {
  const [isOldBrowser, setIsOldBrowser] = useState(false);

  useEffect(() => {
    setIsOldBrowser(isIE());
  });

  return (
    <Layout>
      <SEO title="Strona główna" />

      {typeof window !== 'undefined' && (
        <>
          {isOldBrowser && (
            <div>
              <p>Twoja przeglądarka nie jest wspierana.</p>
              <p>
                Używana przez Ciebie przeglądarka może powodować błędy w wyświetlaniu strony lub nieprzewidziane problemy w funkcjonowaniu mechanizmów Testu
                wiedzy SKO. Skorzystaj z innej przeglądarki.
              </p>
            </div>
          )}
          {!isOldBrowser && isForm && (
            <>
              <Bluebox
                aside={
                  <RegulationButton
                    url={withPrefix('/Test_wiedzy_ekonomicznej_zasady_2026.pdf')}
                    filename={quizContent?.regulationBox?.filename}
                    filetype="pdf"
                    filesize="70,3"
                  />
                }
              >
                <h2>{quizContent?.regulationBox?.title}</h2>
                {!!quizContent?.regulationBox?.list?.length && (
                  <ol>
                    {quizContent.regulationBox.list.map((listItem, index) => (
                      <li key={index}>{listItem}</li>
                    ))}
                  </ol>
                )}
              </Bluebox>
              <div className="form-layout">
                <LoginForm translation={quizContent.form} />
                <div className="form-image">{/* image in styles */}</div>
              </div>
            </>
          )}
          {!isOldBrowser && isQuestions && <Questions />}
          {!isOldBrowser && isResults && <Results />}
        </>
      )}
    </Layout>
  );
};

const mapStateToProps = state => {
  return {
    isForm: !state.root.quiz.questions.length,
    isQuestions: !!state.root.quiz.questions.length && state.root.quiz.percentage === null,
    isResults: !!state.root.quiz.questions.length && state.root.quiz.percentage !== null,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexPage);
